import React from 'react';

export const AppContext = React.createContext({
  setLogoLink: () => {},
  getLogoLink: () => {},
  setShowBackButton: () => {},
  setShowLanguageSwitch: () => {},
  changeLanguage: () => {},
  setNavBarSecondLogo: () => {},
  lng: 'en',
  showBackButton: false,
  showCancelButton: false,
  setShowCancelButton: () => {}
});
